;(function() {
  'use strict'

  angular.module('app.core').component('surveyExplorerManageFiltersDialog', {
    controller: Controller,
    templateUrl: 'survey-explorer-manage-filters-dialog.html',
    bindings: {
      items: '<',
      onAdd: '&',
      onCreate: '&',
      onDone: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.move = move
    ctrl.remove = remove
    ctrl.add = add
    ctrl.create = create
    ctrl.done = done
    ctrl.cancel = cancel

    function onInit() {
      ctrl.items = ctrl.items.slice()
    }

    function move(item, direction) {
      var idx = ctrl.items.indexOf(item)
      var newIdx = _.clamp(idx + direction, 0, ctrl.items.length - 1)
      ctrl.items.splice(newIdx, 0, ctrl.items.splice(idx, 1)[0])
    }

    function remove(item) {
      _.remove(ctrl.items, item)
    }

    function add() {
      var hiddenIds = ctrl.items.map(function(item) {
        return item.filter.id
      })
      ctrl.onAdd({ $hiddenIds: hiddenIds }).then(function(result) {
        if (!result) return
        for (var filter of result.filters) {
          ctrl.items.push({ filter: filter })
        }
      })
    }

    function create() {
      ctrl.onCreate().then(function(filter) {
        if (!filter) return
        ctrl.items.push({ filter: filter })
      })
    }

    function done() {
      ctrl.onDone({ $items: ctrl.items })
    }

    function cancel() {
      ctrl.onCancel()
    }
  }
})()
